import { render, staticRenderFns } from "./UploadProgressBar.vue?vue&type=template&id=920ac02a&scoped=true&"
import script from "./UploadProgressBar.vue?vue&type=script&lang=js&"
export * from "./UploadProgressBar.vue?vue&type=script&lang=js&"
import style0 from "./UploadProgressBar.vue?vue&type=style&index=0&id=920ac02a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "920ac02a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VProgressLinear,VRow})
